import { Link } from '@joehua/react-link';
import * as React from 'react';
import { themr } from 'react-css-themr';
import { JsonLd } from '../JsonLd';
import { getBusinessJsonLd } from '../utils/jsonld';
const DumpBusinessBox = ({ business, addressLabel, telephoneLabel, emailLabel, theme = {}, }) => {
    if (!business) {
        return React.createElement("div", null, "Business Box");
    }
    return (React.createElement("div", { className: theme.root },
        React.createElement(Link, { to: { name: 'home' }, className: theme.nameLink },
            React.createElement("h3", { className: theme.name }, business.name)),
        React.createElement("div", { className: theme.address },
            addressLabel,
            React.createElement("a", { target: "_blank", href: `https://maps.google.com/?q=${business.address}` }, business.address)),
        business.email && (React.createElement("div", { className: theme.emailWrapper },
            React.createElement("span", { className: theme.emailLabel }, emailLabel),
            React.createElement("a", { href: `mailto:${business.email}`, className: theme.email }, business.email))),
        business.telephone && (React.createElement("div", { className: theme.telephoneWrapper },
            React.createElement("span", { className: theme.telephoneLabel }, telephoneLabel),
            React.createElement("a", { href: `tel:${business.telephone}`, className: theme.telephone }, business.telephone))),
        React.createElement(JsonLd, { object: getBusinessJsonLd(business) })));
};
DumpBusinessBox.defaultProps = {
    addressLabel: 'Trụ sở: ',
    telephoneLabel: 'Hotline: ',
    emailLabel: 'Email: ',
};
export const defaultBusinessBoxTheme = {
    root: '',
    nameLink: 'db',
    name: 'f7 f5-l fw7 white-80 pv1 fw7',
    address: 'db f7 f6-l fw4 white-70 pv1',
    email: 'link db f7 f6-l fw4 white-70 pv1',
    telephone: 'link db f7 f6-l fw4 white-70 pv1',
    url: 'link db f7 f6-l fw4 white-70 pv1',
};
const BusinessBox = themr('BusinessBox', {}, { composeTheme: 'softly' })(DumpBusinessBox);
export default BusinessBox;
//# sourceMappingURL=index.js.map